module.exports = __webpack_public_path__ + "static/iso27001_logo-1bd4390068539c3bfa347c9ad48fa280.png";